import { useEffect, useState } from "react";

const navLinks = [
  { href: "#timeline", label: "最新进展" },
  { href: "#series", label: "连续剧" },
  { href: "#reversal", label: "反转·发声" },
  { href: "#official", label: "官方回应" },
  { href: "#rank", label: "新瓜榜" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于我们" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/80"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-20 flex items-center justify-between gap-4">
        <a href="#home" className="flex items-center gap-2 shrink-0 cursor-pointer">
          <span
            className={`w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full transition-colors ${
              scrolled ? "bg-primary-500" : "bg-primary-500"
            }`}
          >
            <i className="ri-water-flash-fill text-lg md:text-xl text-background-50" />
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-label text-xl md:text-2xl transition-colors ${
                scrolled ? "text-foreground-950" : "text-background-50"
              }`}
            >
              瓜田速报
            </span>
            <span
              className={`text-[10px] md:text-xs mt-0.5 transition-colors ${
                scrolled ? "text-foreground-500" : "text-background-200"
              }`}
            >
              网爆吃瓜连续剧追踪站
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`px-3 py-2 rounded-md text-sm whitespace-nowrap transition-colors cursor-pointer ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                  : "text-background-100 hover:text-background-50 hover:bg-background-50/10"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#contact"
            className="hidden md:inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-megaphone-line" />
            我要爆料
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md border cursor-pointer transition-colors ${
              scrolled
                ? "border-background-200 text-foreground-800 hover:bg-background-100"
                : "border-background-50/40 text-background-50 hover:bg-background-50/10"
            }`}
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200 max-h-[calc(100vh-4rem)] overflow-y-auto">
          <nav className="px-4 py-4 flex flex-col" aria-label="移动端导航">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="py-3 px-3 rounded-md text-foreground-800 hover:bg-background-100 hover:text-primary-600 transition-colors cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setMenuOpen(false)}
              className="mt-3 inline-flex items-center justify-center gap-1.5 px-4 py-3 rounded-md bg-primary-500 text-background-50 font-medium hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-megaphone-line" />
              我要爆料
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}